import { render, staticRenderFns } from "./Gestiones.vue?vue&type=template&id=2a1216c6&"
import script from "./Gestiones.vue?vue&type=script&lang=js&"
export * from "./Gestiones.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports